var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 263.159 216.172",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.815 61.489-30.632 7.886-31.05-16.754a7.984 7.984 0 0 0-1.444-.605 10.827 10.827 0 0 0-2.373-.889c-8.547-2.091-20.901 2.601-25.87 17.266-4.778 14.377-6.854 25.187-6.694 38.22.065 5.283.487 10.92 1.262 17.325 1.565 7.868 5.009 12.265 9.188 14.693.856.781 1.83 1.462 2.923 1.998l38.173 18.712 10.331 44.867c1.332 5.784 6.478 9.698 12.171 9.698.929 0 1.872-.104 2.815-.322 6.728-1.549 10.926-8.259 9.377-14.986l-11.667-50.667a12.503 12.503 0 0 0-6.68-8.419l-31.102-15.246c-.598-5.719-.456-11.712.079-17.662.11-1.224.235-2.444.377-3.661L31.805 80.617c-1.615-2.227-2.267-4.95-1.834-7.667s1.897-5.103 4.124-6.718a10.23 10.23 0 0 1 6.041-1.962c3.294 0 6.414 1.59 8.345 4.253l4.466 6.158c.058-.217.115-.435.166-.654l20.231 10.916a7.985 7.985 0 0 0 5.794.707l33.667-8.667a8 8 0 0 0 5.753-9.741c-1.103-4.279-5.464-6.858-9.743-5.753z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.943,
    cy: 26.459,
    r: 22.5,
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.087 113.854-7.628 1.034c-.04 2.66.031 5.296.252 7.88l29.946 14.679c.712.349 1.374.767 2.011 1.216l3.659-10.209a12.5 12.5 0 0 0-2.053-12.084c-.224-.276-.473-.523-.717-.776l-20.611-.392a10.312 10.312 0 0 1-4.859-1.348zM43.399 152.639l2.061 12.95-3.917 10.93c-1.584 4.419-.523 9.139 2.359 12.441H9.797l6.593-41.417h16.613l-9.891-4.849a14.62 14.62 0 0 1-2.308-1.42H8.542a3.017 3.017 0 0 0-3.008 3.008v.253a3.017 3.017 0 0 0 3.008 3.008h2.105L0 214.428l5.601.892 3.198-20.091h41.379l3.198 20.091 5.601-.892-3.407-21.405c4.233-.783 7.95-3.725 9.507-8.069l.461-1.287-5.237-22.743zM46.618 69.873a8 8 0 1 0-12.951 9.394l22 30.333a7.998 7.998 0 0 0 6.323 3.302l43.667.833.155.001a8 8 0 0 0 .149-15.998l-39.683-.757zM193.374 198.138c-7.27.001-13.557-5.429-14.625-12.63l-1.703-11.481-4.65 27.565c-1.148 6.808 3.439 13.257 10.247 14.405.704.118 1.403.176 2.094.176 5.99 0 11.281-4.319 12.311-10.423l1.437-8.517a14.788 14.788 0 0 1-5.111.905zM254.617 147.943a3.017 3.017 0 0 0 3.008-3.008v-.253a3.017 3.017 0 0 0-3.008-3.008h-32.702l1.877-1.538h-21.847l2.887 19.466.77-4.566 8.66-7.094h.565l-10.647 66.885 5.601.892 3.198-20.091h41.379l3.198 20.091 5.601-.892-10.647-66.885h2.107zm-1.255 41.417h-39.383l6.593-41.417h26.198z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.42,
    cy: 22.5,
    r: 22.5,
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.322 137.837c3.967 0 7.496-1.854 9.786-4.737 3.053-2.623 5.494-6.685 6.741-12.954 2.686-22.203 1.281-35.34-5.433-55.544-4.97-14.665-17.324-19.357-25.871-17.266-8.544 2.089-12.352 13.984-9.527 23.95.719 3.761 1.587 7.967 2.428 12.431l2.95-17.583a10.262 10.262 0 0 1 10.145-8.598c.572 0 1.15.048 1.719.144 2.712.455 5.086 1.939 6.683 4.18s2.226 4.969 1.771 7.682l-6.5 38.75a10.266 10.266 0 0 1-11.294 8.533c-2.776-.302-5.971-.462-9.231-.462-13.1 0-23.36 2.375-27.447 6.355a10.246 10.246 0 0 1-7.185 2.92c-.254 0-.505-.019-.756-.037.011.523.045 1.047.122 1.571l8.601 58c.921 6.208 6.257 10.668 12.35 10.668.61 0 1.228-.044 1.85-.137 6.828-1.013 11.543-7.37 10.531-14.198l-6.476-43.667h34.043z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.057 123.337a7.975 7.975 0 0 0 5.58-2.268c7.22-7.03 27.474-7.735 38.538-6.531 4.202.468 8.068-2.44 8.771-6.628l6.5-38.75a8 8 0 0 0-6.566-9.213 7.996 7.996 0 0 0-9.213 6.566l-5.304 31.615c-11.504-.377-32.706.588-43.888 11.477a8 8 0 0 0 5.582 13.732z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.45e386b5f2f6a4832123a24b7e681ad0.svg";
export { ForwardRef as ReactComponent };